import ResponseError from "../types/responseError"
import { HttpStatusCodes } from "./HttpStatusCodes"

export default function buildCarrotApiRetryPolicy(maxFailures: number, additionalCodesToNotRetry: number[] = []) {
  return function (failureCount: number, error: ResponseError): boolean {
    const statusCodesToNotRetry = [
      HttpStatusCodes.UNAUTHORIZED,
      HttpStatusCodes.FORBIDDEN,
      HttpStatusCodes.BAD_REQUEST,
      HttpStatusCodes.NOT_FOUND,
      ...additionalCodesToNotRetry
    ]

    if (error.statusCode === null) {
      // Network error — no response, don't retry
      return false
    }

    return !statusCodesToNotRetry.includes(error.statusCode) && failureCount < maxFailures
  }
}
